import React from "react";

export default function FormIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          d="M21 21V6.75L14.25 0H6C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H18C19.6569 24 21 22.6569 21 21ZM14.25 4.5C14.25 5.74264 15.2574 6.75 16.5 6.75H19.5V13.5H4.5V3C4.5 2.17157 5.17157 1.5 6 1.5H14.25V4.5ZM4.5 18V15H7.5V18H4.5ZM4.5 19.5H7.5V22.5H6C5.17157 22.5 4.5 21.8284 4.5 21V19.5ZM9 22.5V19.5H13.5V22.5H9ZM15 22.5V19.5H19.5V21C19.5 21.8284 18.8284 22.5 18 22.5H15ZM19.5 18H15V15H19.5V18ZM9 18V15H13.5V18H9Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .082h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
